import type { LucideIcon } from 'lucide-react';
import {
  Ban,
  CircleCheck,
  CircleDashed,
  CircleDot,
  CircleDotDashed,
  CircleMinus,
  LoaderCircle,
  ShieldAlert,
  ShieldCheck,
  ShieldX,
} from 'lucide-react';

/** KDS Status Badge — presentational status badge with optional icon. */

export const statusBadgeColorPalettes = ['neutral', 'green', 'red', 'orange', 'blue', 'gradient'] as const;
export type StatusBadgeColorPalette = (typeof statusBadgeColorPalettes)[number];

export const statusBadgeVariants = ['default', 'withIcon'] as const;
export type StatusBadgeVariant = (typeof statusBadgeVariants)[number];

export const statusBadgeSizes = ['sm', 'md'] as const;
export type StatusBadgeSize = (typeof statusBadgeSizes)[number];

export const statusBadgeIconSize = '16px';
export const statusBadgeIconOpacity = 0.8;

export interface StatusBadgeConfig {
  label: string;
  colorPalette: StatusBadgeColorPalette;
  icon: LucideIcon;
}

export const statusBadgeStatuses = [
  'notExposed',
  'approaching',
  'exposed',
  'unpaid',
  'paid',
  'registering',
  'committed',
  'voided',
  'active',
  'approved',
  'unregistered',
  'registered',
  'deregistered',
  'unapproved',
  'partiallyApproved',
] as const;

export type StatusBadgeStatus = (typeof statusBadgeStatuses)[number];

export const statusBadgeConfigMap: Record<StatusBadgeStatus, StatusBadgeConfig> = {
  notExposed: { label: 'Not Exposed', colorPalette: 'neutral', icon: ShieldCheck },
  approaching: { label: 'Approaching', colorPalette: 'orange', icon: ShieldAlert },
  exposed: { label: 'Exposed', colorPalette: 'red', icon: ShieldX },
  unpaid: { label: 'Unpaid', colorPalette: 'neutral', icon: CircleDashed },
  paid: { label: 'Paid', colorPalette: 'green', icon: CircleCheck },
  registering: { label: 'Registering', colorPalette: 'blue', icon: LoaderCircle },
  committed: { label: 'Committed', colorPalette: 'green', icon: CircleCheck },
  voided: { label: 'Voided', colorPalette: 'red', icon: Ban },
  active: { label: 'Active', colorPalette: 'green', icon: CircleDot },
  approved: { label: 'Approved', colorPalette: 'green', icon: CircleCheck },
  unregistered: { label: 'Unregistered', colorPalette: 'neutral', icon: CircleDashed },
  registered: { label: 'Registered', colorPalette: 'green', icon: CircleCheck },
  deregistered: { label: 'Deregistered', colorPalette: 'neutral', icon: CircleMinus },
  unapproved: { label: 'Unapproved', colorPalette: 'neutral', icon: CircleDashed },
  partiallyApproved: { label: 'Partially Approved', colorPalette: 'gradient', icon: CircleDotDashed },
};
